export default {
    UPLOAD_APP_API_INTEGRATION_CSV_PATCH_REQUEST: "UPLOAD_APP_API_INTEGRATION_CSV_PATCH_REQUEST",
    UPLOAD_APP_API_INTEGRATION_CSV_PATCH_RECEIVE: "UPLOAD_APP_API_INTEGRATION_CSV_PATCH_RECEIVE",
    UPLOAD_APP_API_INTEGRATION_CSV_PATCH_ERROR: "UPLOAD_APP_API_INTEGRATION_CSV_PATCH_ERROR",
    RESET_ALL: "RESET_ALL",

    UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_REQUEST: "UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_REQUEST",
    UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_RECEIVE: "UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_RECEIVE",
    UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_ERROR: "UPLOAD_SUBSCRIBER_ORGANISATION_CSV_PATCH_ERROR",

    DOWNLOAD_INTEGRATION_REPORT_CSV_GET_REQUEST: "DOWNLOAD_INTEGRATION_REPORT_CSV_GET_REQUEST",
    DOWNLOAD_INTEGRATION_REPORT_CSV_GET_RECEIVE: "DOWNLOAD_INTEGRATION_REPORT_CSV_GET_RECEIVE",
    DOWNLOAD_INTEGRATION_REPORT_CSV_GET_ERROR: "DOWNLOAD_INTEGRATION_REPORT_CSV_GET_ERROR",  
}